'use client';

import Link from 'next/link';
import { type ReactNode } from 'react';
import { Logo } from '@/components/common/Logo';

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="relative z-10 flex min-h-screen flex-col items-center justify-center p-2 sm:p-4">
      {/* Logo Section */}
      <div className="my-2 flex justify-center">
        <Link href="/" className="block">
          <Logo size="lg" />
        </Link>
      </div>

      {/* Authentication Form */}
      <div className="w-full max-w-md">{children}</div>

      {/* Footer */}
      <div className="mt-4 text-center text-xs text-gray-500">
        <p>© {new Date().getFullYear()} Auction Chase. All rights reserved.</p>
        <div className="mt-2 space-x-4">
          <Link href="/terms" className="hover:text-primary-600">
            Terms of Service
          </Link>
          <Link href="/privacy" className="hover:text-primary-600">
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
}
